var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.774,
    width: 6.452,
    height: 40,
    rx: 3.226,
    fill: "#F9DB6D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 15.483,
    width: 6.452,
    height: 40,
    rx: 3.226,
    transform: "rotate(90 40 15.483)",
    fill: "#F9DB6D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTYuNzc0MiIgd2lkdGg9IjYuNDUxNjEiIGhlaWdodD0iNDAiIHJ4PSIzLjIyNTgxIiBmaWxsPSIjRjlEQjZEIi8+CjxyZWN0IHg9IjQwIiB5PSIxNS40ODM0IiB3aWR0aD0iNi40NTE2MSIgaGVpZ2h0PSI0MCIgcng9IjMuMjI1ODEiIHRyYW5zZm9ybT0icm90YXRlKDkwIDQwIDE1LjQ4MzQpIiBmaWxsPSIjRjlEQjZEIi8+Cjwvc3ZnPgo=";
export { SvgPlus as ReactComponent };